/* eslint-disable no-dupe-keys */
import React, { useState, useEffect } from "react";
/*import { Upload } from "../../EntryFile/imagePath";*/

import AuthUser from "../../components/AuthUser";

import { toast, ToastContainer } from "react-toastify";

import Spinner from "../../components/Spinner";

import { Link, useHistory, useParams } from "react-router-dom";

import Swal from "sweetalert2";

import PropTypes from "prop-types";

import {
  EditIcon,
  DeleteIcon,
  PlusIcon,
} from "../../EntryFile/imagePath";
import { ModalParagrafoEditar } from "../modal/modalParagrafoEditar";
import { ModalParagrafoNovo } from "../modal/modalParagrafoNovo";

const NewformadorEdit = ({
  permissaoAtivar,
  permissaoAtualizar,
  permissaoAcessoAtualizar,
}) => {
  const history = useHistory();

  const { id } = useParams();

  // eslint-disable-next-line no-unused-vars
  const { http, url_root } = AuthUser();

  const [nivelSelecionado, setNivelSelecionado] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);

  const [galeria, setGaleria] = useState(1);

  const [utilizador, setUtilizador] = useState(null);
  const [loading, setLoading] = useState(false);
  const [niveis, setNiveis] = useState([]);
  const [tipo, setTipoSelecionado] = useState(1);
  const [genero, setGenero] = useState(1); 

  const [fotografia, setSelectedFile] = useState(null);
  const [fotografiaPreview, setFotografiaPreview] = useState(null);

  const [inputs, setInputs] = useState([]);

  const [paragrafo_id, setParagrafoID] = useState(0);
  const [tituloParam, setTituloParam] = useState(0);
  const [descricaoParam, setDescricaoParam] = useState("");
  const [ordemParam, setOrdemParam] = useState(1);
  const [iconeParam, setIcone] = useState("");
  const [imagemParam, setImagem] = useState("");

  const [paragrafos, setParagrafos] = useState([]);


  /* TABELA MODAL formacoes */

  const [curso, setcurso] = useState([]);
  const [cursos, setCursos] = useState([]);

  // State to track whether the "checkgeral" checkbox is checked
  const [checkGeral, setCheckGeral] = useState(false);
  const [cursosSelecionados, setcursosSelecionados] = useState([]);

  const [turmas, setTurmas] = useState([]);

  const getTurmas = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/turmas/formador/" + id);

      setTurmas(res.data.turmas);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log("Utilizador não autenticado.");
      } else {
        console.log("Ocorreu um erro inesperado. Por favor, tente mais tarde.");
      }
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  // Function to handle the "checkgeral" checkbox change
  const handleCheckGeralChange = () => {
    // Toggle the checked state
    setCheckGeral(!checkGeral);

    // Get all the "check-curso" checkboxes
    const checkboxes = document.querySelectorAll(".check-curso");

    // Create a new array to store the selected collaborator IDs
    const selectedcursos = [];

    // Set the checked state of each checkbox to match "checkgeral"
    checkboxes.forEach((checkbox) => {
      checkbox.checked = !checkGeral;
      if (checkbox.checked) {
        // Add the ID to the selectedcursos array
        selectedcursos.push(checkbox.dataset.id);
      }
    });

    // Update the state with the selected collaborator IDs
    setcursosSelecionados(selectedcursos);
  };

  // Function to handle the "checkBoxes from table" checkbox change
  const handleCheckBoxChange = () => {
    // Get all the "check-curso" checkboxes
    const checkboxes = document.querySelectorAll(".check-curso");

    // Create a new array to store the selected collaborator IDs
    const selectedcursos = [];

    // Set the checked state of each checkbox to match "checkgeral"
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        // Add the ID to the selectedcursos array
        const cursoId = checkbox.dataset.id;
        console.log("curso ID selecionado:", cursoId);
        selectedcursos.push(cursoId);
      }
    });

    // Update the state with the selected collaborator IDs
    setcursosSelecionados(selectedcursos);
  };

  const vincularFormadorCurso = async () => {
    if (permissaoAtualizar) {
      // Exibe a mensagem de confirmação

      if (cursosSelecionados.length > 0) {
        Swal.fire({
          title: "Tem certeza ?",
          text:
            "Pretende associar os cursos selecionados ao formador [ " +
            inputs?.name +
            " ] ?.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, associar!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              // Envie uma solicitação para a API para eliminar os usuários selecionados
              const response = await http.post("/formador/cursos/associar", {
                cursosSelecionados,
                id,
              });

              getCursos();

              toast.success(response.data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
            } catch (error) {
              console.error(error);

              toast.error(
                "Ocorreu um erro ao associar formacoes ao curso. Por favor, tente novamente mais tarde.",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
            }
          }
        });
      } else {
        toast.error("Tem de selecionar pelo menos um curso", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const desvincularFormadorCurso = async () => {
    if (permissaoAtualizar) {
      // Exibe a mensagem de confirmação

      if (cursosSelecionados.length > 0) {
        Swal.fire({
          title: "Tem certeza ?",
          text:
            "Pretende Desassociar os cursos selecionados do formador [ " +
            inputs?.name +
            " ] ?.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, associar!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              // Envie uma solicitação para a API para eliminar os usuários selecionados
              const response = await http.post("/formador/cursos/desassociar", {
                cursosSelecionados,
                id,
              });

              getCursos();

              toast.success(response.data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
            } catch (error) {
              console.error(error);

              toast.error(
                "Ocorreu um erro ao associar formacoes ao curso. Por favor, tente novamente mais tarde.",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
            }
          }
        });
      } else {
        toast.error("Tem de selecionar pelo menos um formador", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const getCursos = async () => {
    try {
      //setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/cursos/formador/" + id);

      setCursos(res.data.cursos);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log("Utilizador não autenticado.");
      } else {
        console.log("Ocorreu um erro inesperado. Por favor, tente mais tarde.");
      }
    } finally {
      //setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  /* FIM CONSTANTES TABELA MODAL formacoes */

  const [permanecerNaPagina, setPermanecerNaPagina] = useState(true);

  const getNiveis = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/niveis");

      console.log("Carregado...");
      console.log(res.data);

      setNiveis(res.data.niveis);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log("Utilizador não autenticado.");
      } else {
        console.log("Ocorreu um erro inesperado. Por favor, tente mais tarde.");
      }
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  /* permissoes */
  const getPermissoes = async (nivelSelecionado) => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("nivel_id", nivelSelecionado);

      const res = await http.post("/permissoes", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setPermissoes(res.data.permissoes);

      console.log("Permissões :");
      console.log(res.data.permissoes);
    } catch (error) {
      console.error("Ocorreu um erro ao carregar os permissões:", error);
    } finally {
      setLoading(false);
    }
  };

  const getAccoes = async () => {
    try {
      setLoading(true);

      const res = await http.get("/accoes");

      setAccoes(res.data.accoes);

      console.log("Acções");
      //console.log(res.data.accoes);
    } catch (error) {
      console.error("Ocorreu um erro ao carregar os acções:", error);
    } finally {
      setLoading(false);
    }
  };

  /* fim get permissões */

  /* CONSTS INICIO PERMISSÕES */

  const [accoes, setAccoes] = useState([]);
  const [permissoes, setPermissoes] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  /* CONSTS FIM PERMISSÕES */

  const navegarParaLista = () => {
    history.push("/dream-pos/users/formadorlists");
  };

  const irParaCurso = (id) => {
    const element = document.querySelector(".btn-close");

    // Check if the element exists before triggering the click event
    if (element) {
      // Trigger a click event
      element.click();
    }

    history.push("/dream-pos/curso/cursoedit/" + id);
  };

  const irParaTurma = (id) => {
    const element = document.querySelector(".btn-close");

    // Check if the element exists before triggering the click event
    if (element) {
      // Trigger a click event
      element.click();
    }

    history.push("/dream-pos/turma/turmaedit/" + id);
  };

  useEffect(() => {
    setTipoSelecionado(2); //Para formador

    const fetchData = async () => {
      try {
        console.log("Fetching niveis...");
        await getNiveis();
        console.log("Niveis:", niveis);

        console.log("Fetching user data...");
        const userResponse = await http.get("/utilizador/" + id);
        console.log("User data:", userResponse.data.utilizador);

        setUtilizador(userResponse.data.utilizador);

        //if (userResponse.data.utilizador?.tipo == 2) {
          
          setInputs(userResponse.data.utilizador);
          setNivelSelecionado(userResponse.data.utilizador.nivel_id);
          setGenero(userResponse.data.utilizador.genero);
          setTipoSelecionado(userResponse.data.utilizador.tipo);
          setFotografiaPreview(userResponse.data.utilizador.fotografia);

          const resultado = await http.get("/cursos");
          setcurso(resultado.data.cursos);

          getCursos();

          getTurmas();

          mostrarParagrafos();

          console.log("Fetching permissoes...");
          try {
            setLoading(true);

            const formData = new FormData();
            formData.append("nivel_id", userResponse.data.utilizador.nivel_id);

            const res = await http.post("/permissoes", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });

            setPermissoes(res.data.permissoes);

            console.log("Permissões :");
            console.log(res.data.permissoes);
          } catch (error) {
            console.error("Ocorreu um erro ao carregar os permissões:", error);
          } finally {
            setLoading(false);
          }

          console.log("Permissoes:", permissoes);

          console.log("Fetching accões...");
          await getAccoes();
          console.log("Acções:", accoes);
        //}
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleRemoverInscricao = (id) => {
    if (permissaoAtualizar) {
      Swal.fire({
        title: "Tem a certeza que pretende remover esta associação ?",
        text: "O processo não é reversivel, pretende continuar ?",
        type: "warning",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, remover!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      }).then(function (t) {
        if (t.isConfirmed) {
          // Se o usuário confirmar, envie a solicitação
          removerInscricao(id);
        }
      });
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const removerInscricao = async (id) => {
    if (permissaoAtualizar) {
      try {
        const formData = new FormData();
        formData.append("inscricao_id", id);

        const response = await http.post("/turma/remover/formador", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        getTurmas();

        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Atualize a lista de turmas após ativar/desativar
      } catch (error) {
        console.error(error);

        toast.error(
          "Ocorreu um erro ao remover a inscrição. Por favor, tente novamente mais tarde.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const handlePermanecerNaPagina = () => {
    setPermanecerNaPagina(!permanecerNaPagina);
  };

  const handleResetSenha = (id) => {
    if (permissaoAtualizar) {
      // Exibe a mensagem de confirmação
      Swal.fire({
        title: "Tem certeza que quer resetar a senha?",
        text: "Isso irá resetar a senha do usuário.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, resetar senha!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Se o usuário confirmar, envie a solicitação para resetar a senha
          resetarSenha(id);
        }
      });
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const resetarSenha = async (id) => {
    if (permissaoAtualizar) {
      try {
        // Gere uma senha aleatória no cliente
        const senhaAleatoria = Math.random().toString(36).slice(-8);

        // Exiba a senha antes de enviar a solicitação
        alert(`Nova Senha: ${senhaAleatoria}`);

        // Envie uma solicitação para a API para resetar a senha
        const response = await http.post(`/resetar-senha/${id}`, {
          novaSenha: senhaAleatoria,
        });

        // Exiba uma mensagem de sucesso
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } catch (error) {
        // Exiba uma mensagem de erro se ocorrer um problema
        toast.error(
          "Ocorreu um erro ao resetar a senha. Por favor, tente novamente mais tarde.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const getUtilizador = async () => {
    try {
      /* */
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/utilizador/" + id);

      console.log("Carregado...");
      console.log(res.data);

      setInputs(res.data.utilizador);

      setNivelSelecionado(res.data.utilizador.nivel_id);

      setFotografiaPreview(res.data.utilizador.fotografia);

      console.log("User :");
      console.log(res.data.utilizador);

      console.log("Accao_id :");
      console.log(nivelSelecionado);

      //getPermissoes();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log("Utilizador não autenticado.");
      } else {
        console.log("Ocorreu um erro inesperado. Por favor, tente mais tarde.");
      }
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  const handleAtivarDesativar = async (id, newState) => {
    if (permissaoAtivar) {
      try {
        const estado = newState ? 1 : 0;

        const formData = new FormData();
        formData.append("id", id);
        formData.append("estado", estado);

        const response = await http.post("/utilizador/activate", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        getUtilizador();

        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Atualize a lista de utilizadores após ativar/desativar
      } catch (error) {
        console.error(error);

        toast.error(
          "Ocorreu um erro ao atualizar o estado do usuário. Por favor, tente novamente mais tarde.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const handleSelectGaleriaChange = (valor) => {
    setGaleria(valor);
  };

  const handleInputsValueChanged = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
      nivel_id: name === "nivel_id" ? value : prevInputs.nivel_id,
    }));
  };

  const handleFileChange = (e) => {
    const newFile = e.target.files[0];

    // Lógica para processar a imagem, se necessário
    setSelectedFile(newFile);

    // Atualize diretamente o src da imagem
    const newFileURL = URL.createObjectURL(newFile);
    document.getElementById("fotografia").src = newFileURL;

    // Restante do código
  };

  const validateEmail = (email) => {
    // Use a regular expression for basic email validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const toggleLoading = (value) => {
    setLoading(value);
  };

  const submitForm = async () => {
    if (permissaoAtualizar) {
      try {
        toggleLoading(true);

        // Basic form validation
        if (inputs?.name?.length < 2) {
          setError("O nome deve ter pelo menos dois caracteres.");
          setLoading(false);

          // Show a error toast
          toast.error("O nome deve ter pelo menos dois caracteres.", {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          return;
        }

        if (!validateEmail(inputs.email)) {
          setError("O email deve ser válido.");
          toggleLoading(false);

          // Show a error toast
          toast.error("O email deve ser válido.", {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          return;
        }

        await updateUtilizador();

        // If the API call is successful, navigate to the dashboard
        //navigate('/dashboard');
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setError("Utilizador não autenticado.");

          // Show a error toast
          toast.error("Utilizador não autenticado.", {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          setError(
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado"
          );

          // Show a error toast
          toast.error(
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado",
            {
              position: "top-right",
              autoClose: 3000, // Close the toast after 3 seconds
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      } finally {
        toggleLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const updateUtilizador = async () => {
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("name", inputs.name);
      formData.append("email", inputs.email);
      formData.append("nivel_id", nivelSelecionado);
      formData.append("tipo", tipo);
      formData.append("nif", inputs.nif);
      formData.append("telefone", inputs.telefone);
      formData.append("data_nasc", inputs.data_nasc);
      formData.append("genero", genero);
      formData.append("nivel_academico", inputs.nivel_academico);
      formData.append("endereco", inputs.endereco);
      formData.append("habilidades", inputs.habilidades);
      formData.append("fotografia", fotografia);
      formData.append("galeria", galeria);

      const response = await http.post("/update", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // Show a success toast
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          // Redirecionar para a lista de utilizadores após o atualização bem-sucedida
          //history.push('/dream-pos/users/userlists');
          if (!permanecerNaPagina) {
            navegarParaLista();
          }
        },
      });
    } catch (error) {
      console.error(error);

      toast.error(
        "Ocorreu um erro ao carregar o utilizador. Por favor, tente novamente mais tarde.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  /* INICIO PERMISSÕES */

  const handleCheckboxChange = async (nivelId, acaoId, action) => {
    if (permissaoAcessoAtualizar) {
      try {
        setLoading(true);

        const formData = new FormData();
        formData.append("nivel_id", nivelId);
        formData.append("accao_id", acaoId);
        formData.append("tipo", action);

        // Set the value based on the current state (toggle)
        const valor = permissoes.some(
          (obj) =>
            obj.nivel_id === nivelId &&
            obj.accao_id === acaoId &&
            obj[action] === 1
        )
          ? 0
          : 1;
        formData.append("value", valor);

        console.log(nivelId, acaoId, action, valor);

        const res = await http.post("/update-permissao", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        console.log(res);

        if (res) {
          setPermissoes(res.data.permissoes);
        }
      } catch (error) {
        // Show a success toast
        toast.error("Erro ao atualizar permissão:", error, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const handleAtivarDesativarLinha = async (
    nivelSelecionado,
    accao_id,
    valor
  ) => {
    if (permissaoAcessoAtualizar) {
      try {
        setLoading(true);

        const formData = new FormData();
        formData.append("nivel_id", nivelSelecionado);
        formData.append("accao_id", accao_id);
        formData.append("valor", valor);

        console.log(nivelSelecionado, accao_id, valor);

        const res = await http.post("/update-permissao-multipla", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        console.log(res);

        if (res) {
          setPermissoes(res.data.permissoes);
        }
      } catch (error) {
        // Show a success toast
        toast.error("Erro ao atualizar permissão:", error, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const handleSelectRow = (index, accao_id) => {
    // Recupera o estado atual do checkbox "Selecionar tudo" da linha
    const selectAllChecked = document.querySelector(
      `.chk_selecionar_linhas_${index}`
    ).checked;

    console.log(accao_id);

    // Atualiza o estado de todos os checkboxes da linha com base no estado do "Selecionar tudo"
    document
      .querySelectorAll(`.chk_linha_permissao_${index}`)
      .forEach((checkbox) => {
        checkbox.checked = selectAllChecked;
        // Chame a função handleCheckboxChange para atualizar o estado no back-end, se necessário
        // Substitua os valores de nivelSelecionado e cdata.id pelos valores corretos
      });

    const valor = selectAllChecked ? 1 : 0;

    console.log("Valor todos :");
    console.log(valor);

    handleAtivarDesativarLinha(nivelSelecionado, accao_id, valor);
  };

  const handleSelectedAll = async () => {
    if (permissaoAcessoAtualizar) {
      setSelectAllChecked(!selectAllChecked);

      const checkboxes = document.querySelectorAll(".chk_selecionar_linhas");

      try {
        setLoading(true);

        for (let i = 0; i < checkboxes.length; i++) {
          const checkbox = checkboxes[i];

          // Defina o valor para todos os checkboxes (verificar ou desmarcar)
          checkbox.checked = !selectAllChecked;

          const accao_id = checkbox.getAttribute("code");
          const valor = !selectAllChecked ? 1 : 0;

          const formData = new FormData();
          formData.append("nivel_id", nivelSelecionado);
          formData.append("accao_id", accao_id);
          formData.append("valor", valor);

          const res = await http.post("/update-permissao-multipla", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          // Atualize o estado apenas com a última resposta
          if (i === checkboxes.length - 1) {
            const ultima_permissao = res.data.permissoes;
            setPermissoes(ultima_permissao);
          }
        }
      } catch (error) {
        // Mostrar um toast de erro
        toast.error("Erro ao atualizar permissão:", error, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const handleSelectAcessoChange = (id) => {
    setNivelSelecionado(id);

    console.log(id);

    // Fetch new permissions after navigation
    getPermissoes(id);
  };

  /*const handleSelectTipoChange = (id) => {

    setTipoSelecionado(id);

  };*/

  const handleSelectGeneroChange = (id) => {
    setGenero(id);
  };

  /* FIM PERMISSÕES */

  const CursoDaTurma = (curso_id) => {
    const cursoEncontrado = curso?.find((lista) => lista?.id == curso_id);

    // Verifique se o objeto foi encontrado
    if (cursoEncontrado != undefined) {
      return cursoEncontrado;
    } else {
      // Caso não seja encontrado, você pode retornar null ou fazer algo diferente, dependendo do seu caso
      return null;
    }
  };



  const confirmEliminar = (id) => {
    Swal.fire({
      title: "Tem a certeza que quer remover?",
      text: "Não sera possivel reverter o processo!",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, remover!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: !1,
    }).then(function (t) {
      if (t.isConfirmed) {
        // Se o usuário confirmar, envie a solicitação
        handleEliminar(id);
      }
    });
  };

  const handleEliminar = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id);

      const response = await http.post("/paragrafo/eliminar", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      mostrarParagrafos();

      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // Atualize a lista de salas após ativar/desativar
    } catch (error) {
      console.error(error);

      toast.error(
        "Ocorreu um erro ao eliminar o estado do usuário. Por favor, tente novamente mais tarde.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    } finally {
      setLoading(false);
    }
  };

  const onSubmissionSuccess = () => {
    mostrarParagrafos();
  };

  const mostrarParagrafos = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/paragrafos_de/3/" + id);

      //console.log("salas :");
      //console.log(res.data.salas);

      setParagrafos(res.data.paragrafos);

      setLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log("utilizador não autenticado.");
      } else {
        console.log("Ocorreu um erro inesperado. Por favor, tente mais tarde.");
      }

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  const handleAbrirModalEditarParagrafo = (
    id,
    titulo,
    descricao,
    icone,
    imagem,
    ordem
  ) => {
    setParagrafoID(id);
    setTituloParam(titulo);
    setDescricaoParam(descricao);
    setIcone(icone);
    setImagem(imagem);
    setOrdemParam(ordem);

    // Obtenha a referência do elemento
    const triggerModalNovoParagrafo = document.getElementById(
      "trigger_modal_editar_paragrafo"
    );

    // Verifique se o elemento existe antes de chamar o click()
    if (triggerModalNovoParagrafo) {
      // Dispare o evento 'click'
      triggerModalNovoParagrafo.click();
    }
  };

  const handleAbrirModalParagrafo = () => {
    // Obtenha a referência do elemento
    const triggerModalNovoParagrafo = document.getElementById(
      "trigger_modal_novo_paragrafo"
    );

    // Verifique se o elemento existe antes de chamar o click()
    if (triggerModalNovoParagrafo) {
      // Dispare o evento 'click'
      triggerModalNovoParagrafo.click();
    }
  };


  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="titles">
            <i
              alt="Image"
              className="header-image fa fa-users border p-3 rounded-3"
            ></i>
            <div>
              <h4>Gestão de doctores</h4>
              <h6>Editar doctor</h6>
            </div>
          </div>
          <div className="page-btn">
            <Link to="/dream-pos/users/newformador" className="btn btn-added">
              <i className="fa fa-plus"></i>&nbsp; Add Novo Doctor
            </Link>
          </div>
        </div>
        {/* /add */}
        <div className="card">
          <div className="card-body">
            <form className="user">
              <div className="row">
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="form-group">
                    <label>Nome do doctor</label>
                    <input
                      type="text"
                      name="name"
                      id="nome"
                      value={inputs?.name}
                      onChange={handleInputsValueChanged}
                    />
                  </div>
                  <div className="form-group">
                    <label>E-mail</label>
                    <input
                      id="email"
                      name="email"
                      type="text"
                      value={inputs.email}
                      onChange={handleInputsValueChanged}
                    />
                  </div>

                  <div className="form-group">
                    <label>Genero</label>

                    <select
                      className="form-control select"
                      onChange={(e) => handleSelectGeneroChange(e.target.value)}
                      value={genero}
                    >
                      <option value="1" selected={inputs.genero == 1}>
                        Feminino
                      </option>
                      <option value="2" selected={inputs.genero == 2}>
                        Masculino
                      </option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Data Nascimento</label>
                    <input
                      type="date"
                      name="data_nasc"
                      className="form-control"
                      value={inputs.data_nasc}
                      onChange={handleInputsValueChanged}
                    />
                  </div>

                  {/* <div className="form-group">
                    <label>Tipo de utilizador</label>

                    <select className="form-control select" onChange={(e) => handleSelectTipoChange(e.target.value)}
                      value={tipo} >
                      <option value="1" selected={inputs.tipo == 1}>
                        Administrador
                      </option>
                      <option value="2" selected={inputs.tipo == 2}>
                        Formador
                      </option>
                      <option value="3" selected={inputs.tipo == 3}>
                        Formando
                      </option>

                    </select>

                  </div> */}

                  <div className="form-group">
                    <label>Citação</label>
                    <textarea
                      className="form-control"
                      name="habilidades"
                      value={inputs.habilidades}
                      onChange={handleInputsValueChanged}
                    ></textarea>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="form-group">
                    <label>Telefone</label>
                    <input
                      id="telefone"
                      name="telefone"
                      type="text"
                      value={inputs.telefone}
                      onChange={handleInputsValueChanged}
                    />
                  </div>
                  <div className="form-group">
                    <label>Nivel</label>

                    <select
                      onChange={(e) => handleSelectAcessoChange(e.target.value)}
                      value={nivelSelecionado}
                      className="form-control select"
                    >
                      {niveis?.map((cdata) => (
                        <option key={cdata.id} value={cdata.id}>
                          {cdata.designacao}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>NIF</label>
                    <input
                      type="text"
                      name="nif"
                      value={inputs.nif}
                      onChange={handleInputsValueChanged}
                    />
                  </div>

                  <div className="form-group">
                    <label>Nivel Académico</label>
                    <input
                      type="text"
                      name="nivel_academico"
                      value={inputs.nivel_academico}
                      onChange={handleInputsValueChanged}
                    />
                  </div>

                  <div className="form-group">
                    <label>Endereço</label>
                    <input
                      type="text"
                      name="endereco"
                      value={inputs.endereco}
                      onChange={handleInputsValueChanged}
                    />
                  </div>


                  <div className="form-group">
                    <label>No slide do website ?</label>

                    <select
                      className="form-control select"
                      name="galeria"
                      onChange={(e) =>
                        handleSelectGaleriaChange(e.target.value)
                      }
                      value={galeria}
                    >
                      <option value="1" selected={inputs.galeria == 1}>
                        Aparece
                      </option>
                      <option value="2" selected={inputs.galeria == 2}>
                        Não aparece
                      </option>
                    </select>
                  </div>

                </div>


                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="form-group">
                    <label>Ativar / Desativar</label>

                    <div className="status-toggle d-flex justify-content-between align-items-center">
                      <input
                        type="checkbox"
                        id={`user${id}`}
                        className="check"
                        defaultChecked={inputs.estado}
                        onChange={() =>
                          handleAtivarDesativar(id, !inputs.estado)
                        }
                        name={`estado_${id}`}
                      />
                      <label
                        htmlFor={`user${id}`}
                        className="checktoggle"
                      ></label>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Resetar senha</label>

                    <a className="" onClick={() => handleResetSenha(id)}>
                      <i className="fa fa-key"></i>
                    </a>
                  </div>

                  <div className="form-group">
                    {/* Checkbox "Permanecer na Página" */}
                    <label>
                      <input
                        type="checkbox"
                        checked={permanecerNaPagina}
                        onChange={handlePermanecerNaPagina}
                      />
                      &nbsp; Permanecer na Página depois de salvar
                    </label>
                  </div>
                </div>

                {/* Restante do código */}
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="form-group">
                    <label>Fotografia 500X700</label>
                    <div className="image-upload image-upload-new">
                      <input type="file" onChange={handleFileChange} />
                      <div className="image-uploads">
                        {fotografiaPreview ? (
                          <>
                            <img
                              id="fotografia"
                              src={
                                fotografiaPreview
                                  ? url_root + "/storage/" + fotografiaPreview
                                  : URL.createObjectURL(fotografia)
                              }
                              alt="Pré-visualização"
                            />
                            <h4>Carregar fotografia</h4>
                          </>
                        ) : (
                          <>
                            <img id="fotografia" alt="Pré-visualização" />
                            <h4>Carregar fotografia</h4>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Restante do código */}

                {utilizador?.tipo == 2 ? (
                  <>
                    <div className="col-lg-6">
                      <a onClick={submitForm} className="btn btn-submit me-2">
                        {loading ? <Spinner /> : "Salvar"}
                      </a>
                      <a onClick={navegarParaLista} className="btn btn-cancel">
                        Cancelar
                      </a>
                    </div>
                    <div className="col-lg-6">
                      <a
                        href="#"
                        className="btn btn-secondary"
                        data-bs-toggle="modal"
                        data-bs-target="#add_curso"
                      >
                        <i className="fa fa-books"></i> Associar ao tipo
                        consulta
                      </a>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </form>
          </div>
        </div>
        {/* /add */}

        {/* Inicio cursos do formador */}

        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12 mb-3">
                <div className="input-checkset">
                  <ul>
                    <li>
                      <label className="inputcheck"></label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              {loading ? (
                <Spinner />
              ) : (
                <>
                  <table className="table table-bordered" width="100%">
                    <thead>
                      <tr>
                        <th colSpan="5">
                          ESPECIALIDADES DO DOCTOR {inputs?.name?.toUpperCase()}
                        </th>
                        <th>
                          <a
                            className="btn btn-danger"
                            onClick={desvincularFormadorCurso}
                          >
                            <i className="fa fa-times"></i>
                            DESASSOCIAR CONSULTA
                          </a>
                        </th>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            className="form-control-user"
                            checked={checkGeral}
                            onChange={handleCheckGeralChange}
                          />
                        </th>
                        <th>Nº</th>
                        <th>Foto</th>
                        <th>Designação</th>
                        <th>Categoria</th>
                        <th>Operações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cursos?.map((cdata, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              type="checkbox"
                              className="form-control-user check-colaborador"
                              onChange={handleCheckBoxChange}
                              data-id={cdata.curso.id}
                            />
                          </td>
                          <td>{index + 1}</td>

                          <td className="text-center">
                            <img
                              className="img-profile rounded-circle"
                              width="40"
                              height="40"
                              src={url_root + "/storage/" + cdata.curso.imagem}
                              alt="fotografia"
                            />
                          </td>

                          <td>{cdata.curso.designacao}</td>

                          <td>{cdata.curso.categoria}</td>

                          <td>
                            <span
                              className="icon"
                              onClick={() => irParaCurso(cdata.curso.id)}
                            >
                              <i className="fa fa-book"></i>
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>

          
          </div>
        </div>

        {/* fim cursos do formador */}

        {/* INICIO formandos da turma*/}

        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12 mb-3">
                <div className="input-checkset">
                  <ul>
                    <li>
                      <label className="inputcheck"></label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row table-responsive">
              {turmas == null ? (
                <span>Carregando...</span>
              ) : (
                <>
                  <table className="table table-bordered table-responsive datanew dataTable no-footer">
                    <thead>
                      <tr>
                        <th colSpan="6">
                          CONSULTAS DO DOCTOR
                          <hr />
                        </th>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th>Nº</th>
                        <th>Icon</th>
                        <th>Consulta</th>
                        <th>Modo</th>
                        <th>Dias</th>
                        <th>Operações &nbsp;&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {turmas?.map((cdata, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>

                          <td>
                            <img
                              className="img-profile rounded-circle"
                              width="40"
                              height="40"
                              src={
                                url_root +
                                "/storage/" +
                                CursoDaTurma(cdata?.turma?.curso_id)?.imagem
                              }
                              alt="fotografia"
                            />
                          </td>

                          <td>
                            {CursoDaTurma(
                              cdata?.turma?.curso_id
                            )?.designacao.toUpperCase()}{" "}
                            <br></br> {cdata?.turma?.dataIni} -{" "}
                            {cdata?.turma?.dataFim} |{" "}
                            {cdata?.turma?.hora1?.substring(0, 5)} -{" "}
                            {cdata?.turma?.hora2?.substring(0, 5)} &nbsp;&nbsp;
                            <span
                              className="icon"
                              title="Ver info desta turma"
                              onClick={() => irParaTurma(cdata?.turma?.id)}
                            >
                              <i className="fa fa-calendar text-warning"></i>
                            </span>
                          </td>

                          <td>
                            {cdata?.turma?.modo == 1
                              ? "Presencial"
                              : cdata?.turma?.modo == 2
                              ? "Online"
                              : "Hibrido"}
                          </td>

                          <td>
                            {cdata?.turma?.sabados == 2
                              ? "Sábados"
                              : "Segunda á Sexta"}
                          </td>

                          <td>
                            <span
                              className="icon"
                              onClick={() => irParaTurma(cdata.turma.id)}
                              title="editar dados da turma"
                            >
                              <i className="fa fa-pencil"></i>
                            </span>
                            &nbsp;&nbsp;
                            <span
                              className="icon"
                              title="Remover inscrição"
                              onClick={() => handleRemoverInscricao(cdata.id)}
                            >
                              <i className="fa fa-trash text-danger"></i>
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
        </div>

        {/* FIM rmas do formando */}

        {/* Add Event Modal */}
        <div id="add_curso" className="modal custom-modal fade" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Consulta</h5>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true"></span>
                </button>
              </div>

              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="procurar..."
                    />

                    <a
                      className="btn btn-primary"
                      onClick={vincularFormadorCurso}
                    >
                      ADICIONAR SELECIONADOS
                    </a>
                  </div>

                  <div className="form-group">
                    <div className="table-responsive">
                      <table
                        className="table table-dark table-bordered"
                        id="dataTable"
                        width="100%"
                      >
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                className="form-control-user"
                                id="checkgeral"
                                name="chGeral"
                                checked={checkGeral}
                                onChange={handleCheckGeralChange}
                              />
                            </th>
                            <th>Nº</th>
                            <th>Foto</th>
                            <th>Designação</th>
                            <th>Categoria</th>
                            <th>Operações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {curso?.map((cdata, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-control-user check-curso"
                                  onChange={handleCheckBoxChange}
                                  data-id={cdata.id}
                                />
                              </td>
                              <td>{index + 1}</td>
                              <td className="text-center">
                                <img
                                  className="img-profile rounded-circle"
                                  width="40"
                                  height="40"
                                  src={url_root + "/storage/" + cdata.imagem}
                                  alt="Imagem"
                                />
                              </td>
                              <td>{cdata.designacao}</td>
                              <td>{cdata.categoria}</td>
                              <td>
                                <span
                                  className="icon text-white-50"
                                  onClick={() => irParaCurso(cdata.id)}
                                >
                                  <i className="fa fa-pencil"></i>
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add Event Modal */}



        <div className="form-group">
          <div className="table-responsive">
            <table className="table table-bordered" id="dataTable" width="100%">
              <thead>
                <tr>
                  <th>
                    <div className="page-btn">
                      <div
                        onClick={() => handleAbrirModalParagrafo(1, 1)}
                        className="btn btn-primary"
                      >
                        <img src={PlusIcon} alt="img" className="me-1" />
                        Adicionar paragrafo
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th>Imagem</th>
                  <th>Ordem</th>
                  <th>Texto</th>
                </tr>
              </thead>
              <tbody>
                {paragrafos?.map((cdata, index) => (
                  <tr key={index}>
                    <td className="text-center">
                      <img
                        className="img-profile rounded-3"
                        width="50"
                        height="50"
                        src={cdata.imagem != 'null' ? url_root + "/storage/" + cdata.imagem : url_root + "/storage/sample.WEBP"}
                        alt="fotografia"
                      />
                    </td>
                    <td>{cdata.ordem}</td>
                    <td>
                      <div className="icons-container">
                        <div
                          title="editar dados paragrafo"
                          className="me-3"
                          to="#"
                        >
                          <img
                            src={EditIcon}
                            alt="Editar"
                            onClick={() =>
                              handleAbrirModalEditarParagrafo(
                                cdata?.id,
                                cdata?.titulo,
                                cdata?.descricao,
                                cdata?.icone,
                                cdata?.imagem,
                                cdata?.ordem
                              )
                            }
                          />
                        </div>
                        <div
                          title="Eliminar esta paragrafo"
                          className="confirm-text"
                          onClick={() => confirmEliminar(cdata.id)}
                        >
                          <img src={DeleteIcon} alt="Remover" />
                        </div>
                      </div>

                      <div>{cdata?.titulo}</div>

                      <div className="row">
                        <div className="col-sm-2">{cdata?.descricao}</div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>


        <ModalParagrafoNovo  
        onSubmissionSuccess={onSubmissionSuccess}
        tipo={3}
        tipo_id={id}
      /> 

      <ModalParagrafoEditar
        onSubmissionSuccess={onSubmissionSuccess}
        tipo={3}
        tipo_id={id}
        id={paragrafo_id}
        tituloParam={tituloParam}
        descricaoParam={descricaoParam}
        iconeParam={iconeParam}
        imagemParam={imagemParam}
        ordemParam={ordemParam}
      />




        {/* INICIO PERMISSÕES */}

        {permissaoAcessoAtualizar == 2 ? (
          <>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-12 mb-3">
                    <div className="input-checkset">
                      <ul>
                        <li>
                          <label className="inputcheck">
                            Selecionar tudo
                            <input
                              type="checkbox"
                              id="select-all"
                              onChange={() => handleSelectedAll()}
                            />
                            <span className="checkmark" />
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="productdetails product-respon">
                      <ul>
                        {loading ? (
                          <Spinner />
                        ) : (
                          accoes?.map((cdata, index) => {
                            // Find the corresponding object in your array
                            const matchingObject = permissoes?.find((obj) => {
                              return (
                                obj.accao_id == cdata.id &&
                                obj.nivel_id == nivelSelecionado
                              );
                            });

                            return (
                              <li key={index}>
                                <h4 title={cdata.descricao}>
                                  {cdata.designacao}
                                </h4>
                                <div className="input-checkset">
                                  <ul>
                                    <li>
                                      <label className="inputcheck">
                                        Ver
                                        <input
                                          key={cdata.id + "ver"}
                                          type="checkbox"
                                          checked={
                                            matchingObject &&
                                            matchingObject.ver == 1
                                          }
                                          onChange={() =>
                                            handleCheckboxChange(
                                              nivelSelecionado,
                                              cdata.id,
                                              "ver"
                                            )
                                          }
                                          className={
                                            "chk_linha_permissao_" + index
                                          }
                                        />
                                        <span className="checkmark" />
                                      </label>
                                    </li>

                                    <li>
                                      <label className="inputcheck">
                                        Adicionar
                                        <input
                                          type="checkbox"
                                          key={cdata.id + "adicionar"}
                                          checked={
                                            matchingObject &&
                                            matchingObject.adicionar == 1
                                          }
                                          onChange={() =>
                                            handleCheckboxChange(
                                              nivelSelecionado,
                                              cdata.id,
                                              "adicionar"
                                            )
                                          }
                                          className={
                                            "chk_linha_permissao_" + index
                                          }
                                        />
                                        <span className="checkmark" />
                                      </label>
                                    </li>

                                    <li>
                                      <label className="inputcheck">
                                        Atualizar
                                        <input
                                          type="checkbox"
                                          key={cdata.id + "atualizar"}
                                          checked={
                                            matchingObject &&
                                            matchingObject.atualizar == 1
                                          }
                                          onChange={() =>
                                            handleCheckboxChange(
                                              nivelSelecionado,
                                              cdata.id,
                                              "atualizar"
                                            )
                                          }
                                          className={
                                            "chk_linha_permissao_" + index
                                          }
                                        />
                                        <span className="checkmark" />
                                      </label>
                                    </li>

                                    <li>
                                      <label className="inputcheck">
                                        Ativar/Desativar
                                        <input
                                          type="checkbox"
                                          key={cdata.id + "ativar"}
                                          checked={
                                            matchingObject &&
                                            matchingObject.ativar == 1
                                          }
                                          onChange={() =>
                                            handleCheckboxChange(
                                              nivelSelecionado,
                                              cdata.id,
                                              "ativar"
                                            )
                                          }
                                          className={
                                            "chk_linha_permissao_" + index
                                          }
                                        />
                                        <span className="checkmark" />
                                      </label>
                                    </li>

                                    <li>
                                      <label className="inputcheck">
                                        Remover
                                        <input
                                          type="checkbox"
                                          key={cdata.id + "remover"}
                                          checked={
                                            matchingObject &&
                                            matchingObject.remover == 1
                                          }
                                          onChange={() =>
                                            handleCheckboxChange(
                                              nivelSelecionado,
                                              cdata.id,
                                              "remover"
                                            )
                                          }
                                          className={
                                            "chk_linha_permissao_" + index
                                          }
                                        />
                                        <span className="checkmark" />
                                      </label>
                                    </li>

                                    <li>
                                      <label className="inputcheck">
                                        Selecionar tudo
                                        <input
                                          type="checkbox"
                                          checked={
                                            matchingObject &&
                                            matchingObject.ver == 1 &&
                                            matchingObject.adicionar &&
                                            matchingObject.atualizar &&
                                            matchingObject.ativar &&
                                            matchingObject.remover
                                          }
                                          key={cdata.id + "select"}
                                          onChange={() =>
                                            handleSelectRow(index, cdata.id)
                                          }
                                          className={
                                            "chk_selecionar_linhas_" +
                                            index +
                                            " chk_selecionar_linhas"
                                          }
                                          code={cdata.id}
                                        />
                                        <span className="checkmark" />
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                              </li>
                            );
                          })
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}

        {/* FIM PERMISSÕES */}
      </div>

      <ToastContainer />
    </div>
  );
};

NewformadorEdit.propTypes = {
  permissaoAtualizar: PropTypes.bool.isRequired,
  permissaoAtivar: PropTypes.bool.isRequired,
  permissaoAcessoAtualizar: PropTypes.bool.isRequired,
};

export default NewformadorEdit;
